/*
 *  I04DIMPUISSCHAUDI18n.js
 *
 *  Created by Sébastien Hecart on 2017-12-05 16:57:19 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

export default {
  I04DIMPUISSCHAUD_SECTION_0_TITLE: 'Calculer le besoin thermique en fonction de la surface habitable, des données météo et des usages',
  I04DIMPUISSCHAUD_in_surfaceHabitat: 'Surface habitat',
  I04DIMPUISSCHAUD_in_hauteur_plafond: 'Hauteur sous plafond',
  I04DIMPUISSCHAUD_in_tempExtBase: 'Température de base ext',
  I04DIMPUISSCHAUD_in_tempConsigneAmbiance: 'Consigne ambiance',
  I04DIMPUISSCHAUD_coeffG_uuid_mail: 'Type de construction',
  I04DIMPUISSCHAUD_I04CALCULGSIMP: 'Description simplifiée du G',
  I04DIMPUISSCHAUD_I04CALCULGDETA: 'Description détaillée du G',
  I04DIMPUISSCHAUD_SECTION_1_TITLE: '',
  I04DIMPUISSCHAUD_dju_ville: 'Ville',
  I04DIMPUISSCHAUD_dju_uuid: 'Degrè jour unifié moyen ',
  I04DIMPUISSCHAUD_res_coeffG: 'Coefficient G',
  I04DIMPUISSCHAUD_res_puissanceTotale: 'Puissance générateur',
  I04DIMPUISSCHAUD_in_nbJourChauffe: 'Nombre jours de chauffe',
  I04DIMPUISSCHAUD_in_nombreHeureReduit: "Nombre d'heures réduit",
  I04DIMPUISSCHAUD_in_nombreDegreAbaisse: 'Nombre degrés abaissés',
  I04DIMPUISSCHAUD_res_intermittence: 'Intermitence',
  I04DIMPUISSCHAUD_res_deperdition: 'Déperdition',
  I04DIMPUISSCHAUD_res_consoAnnuelleEstime: 'Consommation annuelle estimée',
  I04DIMPUISSCHAUD_calculG_0: 'Choix du G prédéfini',
  I04DIMPUISSCHAUD_calculG_1: 'Calcul manuel du G'
}
